import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M31.683 10.667H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a35 35 0 0 1-.337 5.316H.325a35 35 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.325 21.333H31.66a31 31 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M16 23.333a7.333 7.333 0 1 0 0-14.666 7.333 7.333 0 0 0 0 14.666",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m12.28 21.267 3.743-2.605 3.743 2.605-1.32-4.365 3.633-2.755-4.56-.092-1.496-4.307-1.497 4.307-4.56.092 3.634 2.755zm6.292-1.643-2.55-1.774-2.548 1.774.899-2.973-2.475-1.876 3.105-.063 1.02-2.934 1.02 2.934 3.105.063-2.475 1.876z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m13.6 16.902 2.423 1.76 2.422-1.76-.925-2.847h-2.995zm4.072-.25-1.65 1.198-1.65-1.199.63-1.94h2.04zM15.633 22.6h.667v-2.333h-.667zm6.254-4.06.206-.633-2.22-.721-.205.634zm-1.928-7.201-.54-.392-1.37 1.888.538.391zm-7.445-.392-.54.392 1.372 1.887.54-.391zm-2.674 6.96.206.634 2.22-.721-.207-.634z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagEth = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagEth_default = SvgFlagEth;

export { FlagEth_default as default };
